import { render, staticRenderFns } from "./TvaSlider.vue?vue&type=template&id=7c54ae22&scoped=true&"
import script from "./TvaSlider.vue?vue&type=script&lang=js&"
export * from "./TvaSlider.vue?vue&type=script&lang=js&"
import style0 from "./TvaSlider.vue?vue&type=style&index=0&id=7c54ae22&lang=scss&scoped=true&"
import style1 from "./TvaSlider.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54ae22",
  null
  
)

export default component.exports